import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* FETCH BANNERS */
export const fetchBanners = createAsyncThunk(
  "banner/fetchBanners",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const res = await api.get(`/api/banners?page=${page}&limit=${limit}`);
      return res.data; // expects { data: [...], pagination: {...} }
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch banners");
    }
  }
);

/* CREATE BANNER */
export const createBanner = createAsyncThunk(
  "banner/createBanner",
  async (formData, thunkAPI) => {
    try {
      const res = await api.post(`/api/banners`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to create banner");
    }
  }
);

/* DELETE BANNER */
export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (id, thunkAPI) => {
    try {
      await api.delete(`/api/banners/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Delete failed"
      );
    }
  }
);

/* TOGGLE STATUS */
export const toggleBannerStatus = createAsyncThunk(
  "banner/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(`/api/banners/${id}/status`);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

/* UPDATE BANNER */
export const updateBanner = createAsyncThunk(
  "banner/updateBanner",
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await api.put(`/api/banners/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update banner");
    }
  }
);

const bannerSlice = createSlice({
  name: "banner",
  initialState: {
    banners: [],
    loading: false,
    error: null,
    pagination: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchBanners.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.loading = false;
        state.banners = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createBanner.fulfilled, (state, action) => {
        state.banners.unshift(action.payload);
      })

      /* DELETE */
      .addCase(deleteBanner.fulfilled, (state, action) => {
        state.banners = state.banners.filter(
          (b) => b._id !== action.payload
        );
      })

      /* UPDATE */
      .addCase(updateBanner.fulfilled, (state, action) => {
        const index = state.banners.findIndex(
          (b) => b._id === action.payload._id
        );
        if (index !== -1) {
          state.banners[index] = action.payload;
        }
      })

      /* TOGGLE STATUS */
      .addCase(toggleBannerStatus.fulfilled, (state, action) => {
        const index = state.banners.findIndex(
          (b) => b._id === action.payload._id
        );
        if (index !== -1) {
          state.banners[index] = action.payload;
        }
      });
  },
});

export default bannerSlice.reducer;